export let rootFontSizePx = 16;

export let breakpoints = {
  "mobile": rootFontSizePx * 35,
  "tablet": rootFontSizePx * 45
}